import { AfterViewInit, Component, computed, ElementRef, inject, OnDestroy, signal, viewChild } from "@angular/core"
import { PageMenuComponent } from "./page-menu.component"
import { environment } from "../../environments/environment"
import { RouterLink } from "@angular/router"
import { ProfileService } from "./user-profile/profile.service"
import { FirestoreReadService } from "./content/firestore-read.service"
import { ContentType } from "redlineLibs"
import { TourService } from "./tour/tour.service"
import {
  faBars, faCircle, faCircleInfo, faFolderOpen, faHeadphones, faInbox, faTag, faUser,
} from "@fortawesome/free-solid-svg-icons"
import { PageToolbarService } from "./page-toolbar.service"
import { sort } from "util/sort"
import { PageMenuService } from "./page-menu.service"
import { UiIconComponent } from "ui-icon"
import { RouteService } from "../services/route.service"
import { UtilBreakpointsService } from "util/breakpoints"
import { HelpTipsComponent } from "feature/redline/help-tips"
import { TourComponent } from "./tour/tour.component"
import { ThemeComponent } from "./theme.component"
import { regionsData } from "redlineLibs"
import { StorageService } from "../services/storage.service"

@Component({
  imports: [
    PageMenuComponent,
    RouterLink,
    UiIconComponent,
    HelpTipsComponent,
    TourComponent,
    ThemeComponent,
  ],
  providers: [],
  standalone: true,
  template: `
    @if (showHelpTips()) {
      <lib-feature-help-tips (cancelAndClose)="showHelpTips.set(false)"/>
    }

    <e2e-page-menu/>

    <div
      #pageToolbar
      data-theme="redline_light"
      class="text-primary-content column gap-0 z-20 fixed w-full"
      [style.background-image]="redPaperTexture()"
      (click)="showPageMenu($event)"
    >
      @if (showTour()) {
        <div (click)="$event.stopPropagation()">
          <e2e-tour/>
          <!-- theme needs to be loaded, even though we are hiding it with sr-only -->
          <e2e-theme [visible]="false"/>
        </div>
      }
      @if (!showTour()) {
        @if (breakpointMatches().XSmall) {
          <h1 class="font-bold text-lg center">
            UNDESIGN THE REDLINE
          </h1>
        }

        <div
          class="row font-bold text-lg px-2"
          [class]="breakpointMatches().XSmall ? 'pt-0' : ''"
          style="justify-content: space-between"
        >

          <div class="row gap-0">
            <button
              class="btn text-2xl btn-ghost px-2"
              title="Main Menu"
              (click)="showPageMenu($event)"
            >
              <lib-ui-icon [icon]="faBars"/>
            </button>
            @if (audioTour()) {
              <button
                class="btn text-2xl btn-ghost px-2"
                title="Audio Tour"
                (click)="setShowTour(true); $event.stopPropagation()"
              >
                <lib-ui-icon [icon]="faHeadphones"/>
              </button>
            }
          </div>

          @if (!breakpointMatches().XSmall) {
            <h1 [class]="breakpointMatches().Small ? 'text-md' : 'text-2xl'">
              UNDESIGN THE REDLINE
            </h1>
          }

          <div
            class="row gap-0"
            (click)="$event.stopPropagation()"
          >

            @if (isEditor()) {
              <button
                class="btn text-2xl btn-ghost px-2"
                title="Content Manager"
                [routerLink]="[]"
                [queryParams]="queryParamsList().contentManager"
              >
                <lib-ui-icon [icon]="faFolderOpen"/>
              </button>
            }

            @if (isModerator()) {
              <button
                class="btn text-2xl btn-ghost px-2 relative"
                title="Moderation"
                [routerLink]="[]"
                [queryParams]="queryParamsList().contentModeration"
              >
                @if (allContributedContent_array().length) {
                  <lib-ui-icon [icon]="faInbox"/>
                  <div class="absolute top-0 right-1 text-sm">
                    <lib-ui-icon [icon]="faCircle"/>
                  </div>
                }
                @if (!allContributedContent_array().length) {
                  <lib-ui-icon [icon]="faInbox"/>
                }
              </button>
            }

            @if (loggedIn()) {
              <button
                class="btn text-2xl btn-ghost px-2"
                title="My Stories"
                [routerLink]="[]"
                [queryParams]="queryParamsList().myAccountContent"
              >
                <lib-ui-icon [icon]="faTag"/>
                <!--            <lib-bookmark-->
                <!--              [count]="myContentCount()"-->
                <!--              context="pageTopBar"-->
                <!--            />-->
              </button>
            }
            @if (userInit() && !loggedIn()) {
              <button
                class="btn text-2xl btn-ghost px-2"
                title="My Profile"
                [routerLink]="[]"
                [queryParams]="queryParamsList().myAccountLogin"
              >
                <lib-ui-icon [icon]="faUser"/>
              </button>
            }
            @if (loggedIn()) {
              <button
                class="btn text-2xl btn-ghost px-2"
                title="My Profile"
                [routerLink]="[]"
                [queryParams]="queryParamsList().myAccountProfile"
              >
                @if (profileImage()) {
                  <div class="w-6 aspect-square">
                    <img
                      [src]="imageSrc()"
                      [alt]="userName()"
                      style="clip-path: circle(50%); object-fit: cover; height: 100%"
                    />
                  </div>
                } @else {
                  <lib-ui-icon [icon]="faUser"/>
                }

              </button>
            }

            <e2e-theme/>

            <button
              class="btn text-2xl btn-ghost px-2"
              title="Guide/Info"
              (click)="showHelpTips.set(!showHelpTips())"
            >
              <lib-ui-icon
                [icon]="faCircleInfo"
              />
              <!--            [animation]="helpTipsAnimation()"-->
            </button>

            <!--
                      <button
                        class="btn text-2xl btn-ghost px-2"
                        title="Save All"
                        (click)="saveAllContent()"
                      >
                        <lib-ui-icon
                          [icon]="faPaperclipVertical"
                          [animation]="helpTipsAnimation()"
                        />
                      </button>
            -->

          </div>

        </div>
      }
    </div>
  `,
  selector: "e2e-page-toolbar",
})
export class PageToolbarComponent implements AfterViewInit, OnDestroy {
  private profileService = inject(ProfileService)
  private firestoreReadService = inject(FirestoreReadService)
  private tourService = inject(TourService)
  private pageToolbarService = inject(PageToolbarService)
  private pageMenuService = inject(PageMenuService)
  private routeService = inject(RouteService)
  private breakpointService = inject(UtilBreakpointsService)
  private storageService = inject(StorageService)

  audioTour = computed(() =>
    regionsData[this.routeService.region()].audioTour
  )

  queryParamsList = this.routeService.queryParamsList

  toolbarElement = viewChild.required<ElementRef<HTMLElement>>("pageToolbar")
  redPaperTexture = computed(() => {
    const url = this.storageService.getFileUrl("/assets/images/red-paper-texture.png")
    return "url('" + url + "')"
  })

  isEditor = this.profileService.isEditor
  isModerator = this.profileService.isModerator
  userInit = this.profileService.userInit
  loggedIn = this.profileService.loggedIn
  userName = this.profileService.userName
  image = this.profileService.profileImage

  showHelpTips = signal(false)
  helpTipsAnimation = computed(() => this.showHelpTips() ? undefined : "bounce")

  breakpointMatches = this.breakpointService.breakpointMatches

  allContributedContent_array = computed(() =>
    this.firestoreReadService
      .arrayFromContent()
      .filter((content) => content.status.contentTypes.includes(ContentType.CONTRIBUTED))
      .sort((a, b) => sort(a.settings.title, b.settings.title)),
  )
  myContributedContent_array = computed(() =>
    this.allContributedContent_array().filter(
      (content) => content.userActions.created[0].userId === this.profileService.userId(),
    ),
  )
  myContentCount = computed(
    () =>
      this.firestoreReadService
        .arrayFromContent()
        .filter((content) => content.userActions.created[0].userId === this.profileService.userId()).length,
  )
  profileImage = computed(() => this.profileService.profile()?.profileImage)
  imageSrc = computed(() => {
    const image = this.profileImage()
    return (
      (image &&
        [
          "https://storage.googleapis.com/",
          environment.firebaseConfig.storageBucket,
          "/",
          image.filePath,
          "?",
          image.lastUpdated.seconds,
        ].join("")) ||
      ""
    )
  })

  showTour = this.tourService.showTour
  showMenu = this.pageMenuService.showMenu

  private resizeObserver: ResizeObserver | undefined

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver((entries, _) => {
      for (const entry of entries) {
        this.pageToolbarService.pageToolbarHeight.set(entry.contentRect.height)
      }
    })
    this.resizeObserver.observe(this.toolbarElement().nativeElement)
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect()
  }

  // interactiveMode$ = this.store.select(AppStore.interactiveMode)
  // interactiveModeValue$ = this.store.select(AppStore.interactiveModeValue)

  /*
    changeInteractiveMode() {
      this.store.dispatch(AppStore.TimelineActions.toggleInteractiveMode())
    }
  */

  /*
    @HostListener("window:resize")
    onResize(): void {
      const height = this.pageToolbar?.nativeElement.getBoundingClientRect().height
      const width = this.pageToolbar?.nativeElement.getBoundingClientRect().width
      if (height && height !== this.globalState.get("pageToolbarHeight")) {
        this.globalState.set("pageToolbarHeight", () => height)
      }
      if (width && width !== this.globalState.get("pageWidth")) {
        this.globalState.set("pageWidth", () => width)
      }
    }
  */

  setShowTour(showTour: boolean) {
    this.tourService.setShowTour(showTour)
  }

  showPageMenu(event: Event) {
    event.stopPropagation()
    event.preventDefault()
    this.pageMenuService.toggleMenu()
  }

  saving = false

/*
  saveAllContent() {
    if (!this.saving) {
      this.firestoreWriteService.saveContent(Array.from(this.firestoreReadService.content_map().values()))
        .then(() => {
          console.log("batch saved")
        })

      this.saving = true
    }
  }
*/

  protected readonly faUser = faUser
  protected readonly faFolderOpen = faFolderOpen
  protected readonly faInbox = faInbox
  protected readonly faBars = faBars
  protected readonly faTag = faTag
  protected readonly faHeadphones = faHeadphones
  protected readonly faCircle = faCircle
  protected readonly faCircleInfo = faCircleInfo
}
